import BankStatement from "./BankStatement";
import Invoice from "./Invoice";
import Job from "./Job";
import Payroll from "./Payroll";

const Status = {
  BankStatement,
  Invoice,
  Job,
  Payroll,
};

export default Status;
